import React, { Fragment, useEffect } from 'react';
import Breadcrumb from '../../common/breadcrumb';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  MenuItem,
  Select,
  TextField,
  FormControl,
  InputLabel,
  FormHelperText,
  Switch,
  FormGroup,
  FormControlLabel,
} from '@mui/material';
import { Users } from 'react-feather';
import { userRequest } from '../../../auth/requestMethods';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

const FormDefault = () => {
  const {
    handleSubmit,
    watch,
    reset,
    trigger,
    register,
    control,
    getValues,
    formState: { errors, isValid, isSubmitted },
  } = useForm({
    resolver: yupResolver(userValidationSchema),
    defaultValues: defaultValues,
  });

  React.useEffect(() => {
    trigger();
    const subscription = watch((value, { name }) => trigger(name));
    return () => subscription.unsubscribe();
  }, [watch, trigger]);

  useEffect(() => {
    document.title = 'PFSA | Users | Create';
  }, []);

  const onSubmit = (data) => {
    if (data !== '') {
      toast.info('Creating...', {
        isLoading: true,
        position: 'bottom-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        toastId: 'createUser',
        theme: 'colored',
      });

      userRequest()
        .post('/users/', data)
        .then(() => {
          toast.update('createUser', {
            pauseOnFocusLoss: false,
            autoClose: 5000,
            isLoading: false,
            type: 'success',
            render: 'Successfully created. Email was sent to ' + watch('email'),
          });
          reset(defaultValues);
        })
        .catch(({ response }) => {
          toast.update('createUser', {
            pauseOnFocusLoss: false,
            autoClose: 5000,
            isLoading: false,
            type: 'error',
            render: response?.data?.message || 'something went wrong',
          });
        });
    } else {
      errors.showMessages();
    }
  };
  return (
    <Fragment>
      <Breadcrumb link="/users/manage" icon={<Users />} title="create" parent="User" />
      <div className="col-sm-12">
        <div className="card">
          <div className="card-header">
            <h5>Create User</h5>
          </div>
          <div className="card-body">
            <form className="theme-form" noValidate="" onSubmit={handleSubmit(onSubmit)}>
              <div className="form-group row">
                <TextField
                  label="Email"
                  variant="outlined"
                  {...register(`email`)}
                  helperText={
                    errors.email?.message && watch('email') !== '' ? (
                      <p className="text-danger">This is not a valid email</p>
                    ) : (
                      ''
                    )
                  }
                  error={!!(errors.email?.message && isSubmitted && getValues().email === '')}
                  inputProps={{
                    style: {
                      color: 'black',
                    },
                  }}
                />
              </div>
              <div className="form-group row">
                <TextField
                  label="Name"
                  variant="outlined"
                  {...register(`name`)}
                  // helperText={errors.name?.message && isSubmitted ? errors.name.message : ''}
                  error={!!(errors.name?.message && isSubmitted && getValues().name === '')}
                  inputProps={{
                    style: {
                      color: 'black',
                    },
                  }}
                />
              </div>
              <div className="form-group row">
                <TextField
                  label="Surname"
                  variant="outlined"
                  {...register(`surname`)}
                  // helperText={errors.surname?.message && isSubmitted ? errors.surname.message : ''}
                  error={!!(errors.surname?.message && isSubmitted && getValues().surname === '')}
                  inputProps={{
                    style: {
                      color: 'black',
                    },
                  }}
                />
              </div>
              <div className="form-group row">
                <Controller
                  control={control}
                  name="role"
                  defaultValue={0}
                  render={({ field }) => (
                    <FormControl error={!!(errors.role?.message && isSubmitted && getValues().role === '')}>
                      <InputLabel id="demo-simple-select-helper-label">Role</InputLabel>
                      <Select
                        name={field.name}
                        value={field.value}
                        onBlur={field.onBlur}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                        }}
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        label="Role"
                      >
                        <MenuItem value="">- Select -</MenuItem>
                        <MenuItem value="VIEWER">VIEWER</MenuItem>
                        <MenuItem value="APPLICATOR">APPLICATOR</MenuItem>
                        <MenuItem value="SUPERUSER">SUPERUSER</MenuItem>
                        <MenuItem value="ADMINISTRATOR">ADMINISTRATOR</MenuItem>
                      </Select>
                      {/* <FormHelperText>{errors.role?.message && isSubmitted ? errors.role.message : ''}</FormHelperText> */}
                    </FormControl>
                  )}
                />
              </div>
              <div className="d-flex justify-content-start my-4">
                <FormGroup>
                  <FormControlLabel
                    control={<Switch {...register('is_active')} defaultChecked />}
                    label="Active Status"
                    sx={{ margin: 0 }}
                    labelPlacement="start"
                  />
                </FormGroup>
              </div>
              <div>
                <button className="btn btn-primary me-1" type="submit">
                  Create
                </button>
                <Link to={`${process.env.PUBLIC_URL}/users/manage`}>
                  <button className="btn btn-secondary" type="button">
                    Cancel
                  </button>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default FormDefault;

const defaultValues = {
  name: '',
  surname: '',
  email: '',
  is_active: true,
  role: '',
};

const userValidationSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  surname: Yup.string().required('Required'),
  email: Yup.string().email('Not a proper email').required('Required'),
  role: Yup.string().required('Required'),
  is_active: Yup.boolean().default(true),
});
